import { buttonClass } from "@jkast90/kast-common/ui";
import { SHOP_URL } from "../components/Header";
import SignupForm from "../components/SignupForm";
import VideoFacade from "../components/VideoFacade";

// The content of salvagersgame.com, section for section: the wordmark and
// box, what the game is, the captains, the ships, the art and its videos, and
// the sign-up.
// Images are the originals from the old site (ui/public/images).

const CAPTAINS = [
  { src: "/images/captain-leeroy-waylon.png", alt: "Salvaging license of Leeroy Waylon, a human captain" },
  { src: "/images/captain-mad-eyes-elton.png", alt: 'Salvaging license of "Mad Eyes" Elton, a Benthan captain' },
];

const SHIPS = [
  { src: "/images/ship-zephyr-cradle.png", alt: "The Zephyr Cradle ship card, a Kickstarter exclusive" },
  { src: "/images/ship-space-whale.png", alt: "The Space Whale ship card" },
];

// No-cookie embeds, loaded on click: this site has no cookie banner, the old
// one did. Their thumbnails are in ui/public/images.
const VIDEOS = [
  { id: "kv9Z6L0psnA", title: "Salvagers - Intro Video" },
  { id: "mj-G8X64fhY", title: "Salvagers - Art Overview" },
];

export default function HomePage() {
  return (
    <main className="home">
      <section className="hero">
        {/* The wordmark is the page's title; the heading's name is its alt text. */}
        <h1>
          <img className="wordmark" src="/images/wordmark.png" alt="Salvagers, a game by Jake Kast" />
        </h1>
        <img className="box" src="/images/box.png" alt="The Salvagers box" />
        <a className={buttonClass({ variant: "primary", size: "lg" })} href={SHOP_URL} target="_blank" rel="noreferrer">
          Buy the game <span className="muted-on-accent">on TheGameCrafter</span>
        </a>
        <p className="lead">
          Salvagers is a competitive engine building game, designed for 2-4 players. You take the role as one of 10
          ship captains, flying one of 6 ships. Your goal is to search the scrap yard, adding parts onto your ship to
          increase your stats, all while disrupting others trying to do the same. Every round brings a new random event
          that could help or hinder your plans. Every game is unique.
        </p>
      </section>

      <section id="what" className="band">
        <h2>What is Salvagers?</h2>
        <p>
          The base game comes with 10 unique captains. Each captain has a one-time ultimate ability that can turn the
          tide of the game in your favor. Each captain also comes with flavor in the form of a backstory and complete
          salvaging license.
        </p>
        <ul className="facts" aria-label="At a glance">
          <li>2-4 Players</li>
          <li>45-60 Minutes</li>
          <li>Ages 14+</li>
        </ul>
      </section>

      <section id="captains" className="band">
        <h2>Meet the Captains.</h2>
        <div className="cards wide">
          {CAPTAINS.map((card) => (
            <img key={card.src} src={card.src} alt={card.alt} loading="lazy" />
          ))}
        </div>
      </section>

      <section id="ships" className="band">
        <h2>Explore the Ships.</h2>
        <div className="cards tall">
          {SHIPS.map((card) => (
            <img key={card.src} src={card.src} alt={card.alt} loading="lazy" />
          ))}
        </div>
        <p>
          The base game comes with 6 ships. Each ship provides your starting stats. As the game progresses, you will
          add parts to your ship, enhancing the various stats.
        </p>
        <p className="muted">The Zephyr Cradle is a Kickstarter Exclusive, only for those that support.</p>
      </section>

      <section id="art" className="band">
        <h2>Enjoy the Art.</h2>
        <p>
          The art in the game was all human-drawn (Not A.I.). It is all vector art done via Inkscape. Done by Jake
          during their free time over the course of ~10 months.
        </p>
        <p>It had many inspirations, not least of which were: Futurama, Star Trek: Lower Decks, and Rick and Morty.</p>
        <p>
          Want to see yourself in this style? Well, there will be a high-level Kickstarter tier that will include you
          getting your very own Captain drawn in the style and sent to you along with your game!
        </p>
        <div className="videos">
          {VIDEOS.map((video) => (
            <VideoFacade key={video.id} id={video.id} title={video.title} />
          ))}
        </div>
      </section>

      <section id="updates" className="band">
        <h2>Hear about the Kickstarter.</h2>
        <SignupForm />
      </section>
    </main>
  );
}
